









import { Component, Vue } from 'vue-property-decorator'
import PageFooter from '@/components/MutedFooter.vue'

@Component({
  components: {
    PageFooter
  }
})
export default class MutedContainer extends Vue {}
